<template>
    <div class="main">
        <div class="body-content">
            <div class="page-header">
                <h1>Ship Movement</h1>
                <div class="header-actions">
                    <button class="excel-button compact" @click="openNotSailedVesselsModal">Not Sailed Vessels</button>
                    <button class="excel-button compact" @click="OpenReportModal">Report</button>
                </div>
            </div>
            <div class="form-group">
                <div class="form-item2">
                    <label for="vesselName">Vessel *</label>
                    <v-select :clearable="false" id="vesselName" placeholder="Select Vessel" v-model="vesselID"
                        ref="vesselName" :options="vessel" label="Name" :reduce="vessel => vessel.Vesselid"
                        selectOnTab="True" />
                </div>
                <div class="form-item2">
                    <label for="voyageName">Voyage *</label>
                    <v-select :clearable="false" id="voyageName" v-model="voyageID" :options="voyage" label="Name"
                        :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
                </div>
                <div class="form-item2">
                    <label for="area">Area *</label>
                    <v-select :clearable="false" id="area" v-model="areaID" :options="Area" label="Name"
                        :reduce="area => area.locationid" selectOnTab="True" />
                </div>
                <div class="form-item2">
                    <label for="vcnname">VCN No *</label>
                    <v-select :clearable="false" id="vcnname" v-model="vcnID" :options="vcns" label="vcnName"
                        :reduce="vcn => vcn.vcnID" selectOnTab="True" />
                </div>
                <div class="form-item2">
                    <button type="button" class="excel-button" @click="getShipMovement">Show Movements</button>
                </div>
            </div>
            <hr />
            <div class="table-container">
                <table class="transaction-table table-design">
                    <thead>
                        <tr>
                            <th>
                                <span>Sl. No</span>
                            </th>
                            <th>
                                <span>Move Name</span>
                            </th>
                            <th>
                                <span>Place</span>
                            </th>
                            <th>
                                <span>Berth</span>
                            </th>
                            <th>
                                <span>Date</span>
                            </th>
                            <th>
                                <span>Time</span>
                            </th>
                            <th>
                                <span>Remarks</span>
                            </th>
                            <th>
                                <span>Actions</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ld, index) in fetchedList" :key="ld[0]" class="successful-task">
                            <td>{{ index + 1 }}</td>
                            <td>{{ ld['move'] }}</td>
                            <td>{{ ld['terminal'] }}</td>
                            <th>
                                <span>{{ ld['place'] }}</span>
                            </th>
                            <th>
                                <span>{{ formatDate(ld['movedate']) }}</span>
                            </th>
                            <th>
                                <span>{{ formatTime(ld['movetime']) }}</span>
                            </th>
                            <th>
                                <span>{{ ld['remarks'] }}</span>
                            </th>
                            <th>
                                <i v-if="index === fetchedList.length - 1" class="fas fa-trash"
                                    @click="removeMovement(ld)" style="margin-left: 10px; color: red;"></i>
                            </th>

                        </tr>
                    </tbody>
                </table>
                <div class="add-movement-wrapper" v-if="hasFetchedMovements">
                    <button class="excel-button" @click="openAddOverlay" title="Add Movement">
                        <i class="fas fa-plus"></i> Add Movement
                    </button>
                </div>
            </div>
            <div v-if="showAddModal" class="modal-overlay">
                <div class="modal-content small">
                    <div class="modal-header">
                        <div>
                            <h3 style="margin: 0;">Add Ship Movement</h3>
                            <p class="modal-subtitle">Vessel: <span class="modal-subtitle-value">{{ selectedVesselName
                                || 'N/A' }}</span></p>
                            <p class="modal-subtitle">Export Voyage: <span class="modal-subtitle-value">{{
                                selectedExportVoyageName || 'N/A' }}</span> | Import Voyage: <span
                                    class="modal-subtitle-value">{{ selectedImportVoyageName || 'N/A' }}</span></p>
                            <p class="modal-subtitle" v-if="lastMovement">Last Movement: <span
                                    class="modal-subtitle-value">{{ lastMovement.move }} At {{ lastMovement.place }} at
                                    {{ lastMovement.date }} and {{ lastMovement.time }}</span></p>
                        </div>
                        <button class="close-btn" @click="showAddModal = false">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <!-- Movement and Place can be dropdowns with predefined options -->
                            <div class="form-item">
                                <label for="vcnname">Movement *</label>
                                <select v-model="move">
                                    <option value="">Select Move</option>
                                    <option v-for="m in movelist" :key="m" :value="m">{{ m }}</option>
                                </select>
                            </div>
                            <div class="form-item">
                                <label for="place">Berth *</label>
                                <select v-model="place">
                                    <option value="">Select Berth</option>
                                    <option v-for="p in placelist" :key="p" :value="p">{{ p }}</option>
                                </select>
                            </div>
                            <div class="form-item">
                                <label for="terminal">Place *</label>
                                <select v-model="terminal">
                                    <option value="">Select Place</option>
                                    <option v-for="p in terminallist" :key="p" :value="p">{{ p }}</option>
                                </select>
                            </div>
                            <!-- Date and Time can be input fields with type date and time respectively -->
                            <div class="form-item3">
                                <label for="date">Date *</label>
                                <input type="text" v-model="date" id="date" />
                            </div>
                            <div class="form-item3">
                                <label for="time">Time *</label>
                                <input type="text" v-model="time" id="time" />
                            </div>
                            <!-- Remarks can be a textarea -->
                            <div class="form-item3" style="width: 100%;">
                                <label for="remarks">Remarks</label>
                                <textarea v-model="remarks" id="remarks" rows="3" style="width: 100%;"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="cancel-button" @click="showAddModal = false"
                            :disabled="isSubmitting">Cancel</button>
                        <button class="save-button" @click="saveVcn" :disabled="isSubmitting">Save</button>
                    </div>
                </div>
            </div>
            <div v-if="showConfirmModal" class="modal-overlay">
                <div class="modal-content small">
                    <div class="modal-header">
                        <div>
                            <h3 style="margin: 0;">Confirm Deletion</h3>
                        </div>
                        <button class="close-btn" @click="cancelDelete">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p>Are you sure you want to remove this movement?</p>
                        <p v-if="movementToDelete"><strong>{{ movementToDelete.move }}</strong> on {{
                            formatDate(movementToDelete.movedate) }} at {{ formatTime(movementToDelete.movetime) }}</p>
                        <p>Vessel: <strong>{{ selectedVesselName }}</strong></p>
                        <p>Export Voyage: <strong>{{ selectedExportVoyageName }}</strong> | Import Voyage: <strong>{{
                            selectedImportVoyageName }}</strong></p>
                    </div>
                    <div class="modal-footer">
                        <button class="cancel-button" @click="cancelDelete">Cancel</button>
                        <button class="save-button" @click="proceedDelete"
                            style="background-color: #dc3545; border-color: #dc3545;">Delete</button>
                    </div>
                </div>
            </div>
            <div v-if="showNotSailedVesselsModal" class="modal-overlay">
                <div class="modal-content small">
                    <div class="modal-header">
                        <div>
                            <h3 style="margin: 0;">Not Sailed Vessels</h3>
                        </div>
                        <div class="search-row header-search-row">
                            <select v-model="searchNotSailedQuery" class="search-select" style="margin-left: 80px;">
                                <option value="">All</option>
                                <option value="NA">No Move</option>
                                <option value="Arrived">Arrived</option>
                                <option value="Waiting">Waiting</option>
                                <option value="Berth">Berth</option>
                                <option value="Commenced">Commenced</option>
                                <option value="Suspended">Suspended</option>
                                <option value="Resumed">Resumed</option>
                                <option value="Completed">Completed</option>

                            </select>
                            <input
                                type="text"
                                v-model="searchNotSailedQuery"
                                placeholder="Search VCN, Vessel, Export/Import Voyage, Berth"
                                class="search-input" style="width: 250px;"
                            />
                        </div>
                        <button class="close-btn" @click="showNotSailedVesselsModal = false">&times;</button>
                    </div>
                    <div class="modal-body">
                        <!-- Content for Not Sailed Vessels Modal -->
                        <table class="transaction-table table-design">
                            <thead>
                                <tr>
                                    <th><span>VCN No</span></th>
                                    <th><span>Vessel Name</span></th>
                                    <th><span>Export Voyage</span></th>
                                    <th><span>Import Voyage</span></th>
                                    <th><span>Berth/Place</span></th>
                                    <th><span>Last</span></th>
                                    <th><span>Actions</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(vessel, index) in filteredNotSailedVessels" :key="index">
                                    <td>{{ vessel.vcnName }}</td>
                                    <td>{{ vessel.vessname }}</td>
                                    <td>{{ vessel.exp_voy }}</td>
                                    <td>{{ vessel.imp_voy }}</td>
                                    <td>{{ vessel.area }}</td>
                                    <td>{{ vessel.move }}</td>
                                    <td>
                                        <button class="excel-button compact"
                                            @click="vcnID = vessel.vcnID; showNotSailedVesselsModal = false; getShipMovement()">View
                                            Movements</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button class="cancel-button" @click="showNotSailedVesselsModal = false">Close</button>
                    </div>
                </div>
            </div>
            <div v-if="showReportModal" class="modal-overlay">
                <div class="modal-content small">
                    <div class="modal-header">
                        <div>
                            <h3 style="margin: 0;">Ship Movement Report</h3>
                        </div>
                        <button class="close-btn" @click="showReportModal = false">&times;</button>
                    </div>
                    <div class="modal-body">
                        <!-- Add filter for Ship Movement Report. Filter by Movement, From Date and To Date, filter feilds in line with search btn  -->
                        <div class="filter-row">
                            <div class="filter-section">
                                <label for="movement-filter">Movement:</label>
                                <select id="movement-filter" v-model="selectedMovement">
                                    <option value="">All</option>
                                    <option v-for="movement in movelist" :key="movement" :value="movement">{{ movement
                                    }}</option>
                                </select>
                            </div>
                            <div class="filter-section">
                                <label for="from-date">From Date:</label>
                                <input type="text" id="from-date" v-model="fromDate" placeholder="dd/mm/yyyy"
                                    @input="formatDateInput" @keydown="handleBackspace">
                            </div>
                            <div class="filter-section">
                                <label for="to-date">To Date:</label>
                                <input type="text" id="to-date" v-model="toDate" placeholder="dd/mm/yyyy"
                                    @input="formatDateInput" @keydown="handleBackspace">
                            </div>
                            <button class="search-button" @click="filterMovements">Search</button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="cancel-button" @click="showReportModal = false">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
export default {
    components: {
        VSelect,
    },
    data() {
        return {
            isSubmitting: false,
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            vcns: [],
            Area: [],
            areaID: 0,
            isLoading: false,
            error: null,
            vcnID: 0,
            vesselID: 0,
            voyageID: 0,
            showAddModal: false,
            showReportModal: false,
            showNotSailedVesselsModal: false,
            notSailedVessels: [],
            searchNotSailedQuery: '',
            fetchedList: [],
            hasFetchedMovements: false,
            showConfirmModal: false,
            movementToDelete: null,
            move: '',
            movelist: ["Arrived", "Waiting", "Berth", "Commenced", "Suspended", "Resumed", "Completed", "Sailing"],
            place: '',
            terminal: '',
            placelist: ["Sandheads", "BUOYS", "NA", "1 NSD", "2NSD", "3 NSD", "4 NSD", "5 NSD", "6 NSD", "7 NSD", "8 NSD", "11 NSD", "12 NSD", "13 NSD", "14 NSD", "1 HDC", "2 HDC", "3 HDC", "4 HDC", "5 HDC", "6 HDC", "7 HDC", "8 HDC"],
            terminallist: ["CPY", "MHC", "NA"],
            date: '',
            time: '',
            remarks: '',
            selectedMovement: '',
            fromDate: '',
            toDate: '',
        }
    },
    computed: {
        selectedVesselName() {
            const vcn = this.vcns.find(v => v.vcnID === this.vcnID);
            if (vcn) {
                return vcn.VesselName || vcn.vesselName || vcn.vessel_name || '';
            }
            const sel = this.vessel.find(v => v.Vesselid === this.vesselID);
            return sel ? sel.Name || sel.VesselName : '';
        },
        selectedExportVoyageName() {
            const vcn = this.vcns.find(v => v.vcnID === this.vcnID);
            if (vcn) {
                return vcn.export_voyageName || vcn.export_voyage || '';
            }
            const sel = this.voyage.find(v => v.Voyageid === this.voyageID);
            return sel ? sel.export_voyageName || sel.Name || sel.VoyageName : '';
        },
        selectedImportVoyageName() {
            const vcn = this.vcns.find(v => v.vcnID === this.vcnID);
            if (vcn) {
                return vcn.import_voyageName || vcn.import_voyage || '';
            }
            const sel = this.voyage.find(v => v.Voyageid === this.voyageID);
            return sel ? sel.import_voyageName || sel.Name || sel.VoyageName : '';
        },
        filteredNotSailedVessels() {
            if (!this.searchNotSailedQuery) {
                return this.notSailedVessels;
            }
            
            // Special case: if "NA" is selected, show vessels with no move
            if (this.searchNotSailedQuery === "NA") {
                return this.notSailedVessels.filter(vessel => !vessel.move || vessel.move === null || vessel.move === '');
            }
            
            const query = this.searchNotSailedQuery.toLowerCase();
            return this.notSailedVessels.filter(vessel => {
                return [
                    vessel.vcnName,
                    vessel.vessname,
                    vessel.exp_voy,
                    vessel.imp_voy,
                    vessel.area,
                    vessel.move
                ].some(value => value && value.toString().toLowerCase().includes(query));
            });
        },
        lastMovement() {
            if (this.fetchedList.length > 0) {
                const last = this.fetchedList[this.fetchedList.length - 1];
                console.log('Last movement for display:', last);
                return {
                    move: last.move,
                    date: this.formatDate(last.movedate),
                    time: this.formatTime(last.movetime),
                    place: last.place,
                    terminal: last.terminal
                };
            }
            return null;
        }
    },
    mounted() {
        this.fetchVcnList();
        this.fetchMasterLocations();
    },
    watch: {
        'vcnID'(value) {
            this.FillVCNDetails(value)
        },
        'vesselID'() {
            this.updateVCNFromVesselAndVoyage();
        },
        'voyageID'() {
            this.updateVCNFromVesselAndVoyage();
        },
        'areaID'() {
            this.updateVCNFromVesselAndVoyage();
        }
        //Select VCN on change vessel and voyageID 


    },
    methods: {
        async fetchMasterLocations() {
            this.isLoading = true;
            this.error = null;

            const token = localStorage.getItem('access_token');

            if (!token) {
                this.error = 'No token found in localStorage';
                this.isLoading = false;
                return;
            }

            try {
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };

                const response = await axios.get('/master_location_list/', config);
                console.log('Master Locations response:', response.data);
                this.Area = response.data[2];
            } catch (error) {
                console.error('Error fetching Master Locations:', error);
                this.error = 'Error fetching Master Locations. Check console for details.';
            } finally {
                this.isLoading = false;
            }
        },
        openAddOverlay() {
            if (!this.vcnID || this.vcnID === 0) {
                useToast().error('Please select VCN first to add movement.');
                return;
            }
            this.terminal = this.lastMovement ? this.lastMovement.terminal : '';
            this.place = this.lastMovement ? this.lastMovement.place : '';

            this.showAddModal = true;
        },
        OpenReportModal() {
            this.showReportModal = true;
        },
        openNotSailedVesselsModal() {
            this.fetchNotSailedVessels();
            this.showNotSailedVesselsModal = true;
        },
        async fetchNotSailedVessels() {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const response = await axios.get('/get_lastmovement', config);
                this.notSailedVessels = response.data[2] || [];
                console.log('Not sailed vessels response:', this.notSailedVessels);
                // Handle the response data as needed
            } catch (error) {
                console.error('Error fetching not sailed vessels:', error);
                useToast().error(error.response?.data?.message || 'Error fetching not sailed vessels.');
            }

        },
        formatTime(time) {
            if (time && time.length === 4) {
                return time.slice(0, 2) + ':' + time.slice(2);
            }
            return time;
        },
        formatDate(date) {
            if (date) {
                const d = new Date(date);
                return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
            }
            return date;
        },
        async fetchVcnList() {
            const token = localStorage.getItem('access_token');
            try {
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }

                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const response = await axios.get('/active_vcn_list/', config);
                var data = response.data[2]
                data.push({ "vcnID": 0, "vcnName": "Select VCN", "vesselID": 0, "import_voyage": 0, "export_voyage": 0, "MlocID": 0, "ImpRotNo": "", "ImpRotDate": null, "ExpRotNo": "", "ExpRotDate": null, "BerthDate": null, "EgmDate": null, "SailDate": null, "IsSail": 0, "vesselLocation": 0, "created_by": 0, "CreateDate": null, "last_modified_by": 0, "ModiDate": null, "VesselName": "", "import_voyageName": "", "export_voyageName": "", "area": "", "Vesselarea": "" })
                this.vcns = data;
            } catch (error) {
                console.error('Error fetching VCN list:', error);
                useToast().error(error.response?.data?.message || 'Error fetching VCN list.');
            }
        },
        FillVCNDetails(value) {
            const selvcn = this.vcns.find(vcn => vcn.vcnID === value);
            console.log('Selected VCN details:', selvcn);
            if (selvcn && selvcn.vcnID !== 0) {
                this.vesselID = selvcn.vesselID;
                this.voyageID = selvcn.export_voyage;
                this.areaID = selvcn.MlocID; // Assuming MlocID corresponds to Area
                if (selvcn.MlocID == 210) {
                    this.terminal = "MHC";
                } else if (selvcn.MlocID == 211) {
                    this.terminal = "CPY";
                } else {
                    this.terminal = "NA";
                }
            } 
        },
        updateVCNFromVesselAndVoyage() {
            this.vcnID = 0; // Reset VCN ID when vessel or voyage changes
            if (this.vesselID && this.voyageID && this.areaID) {
                const matchingVcn = this.vcns.find(vcn => vcn.vesselID === this.vesselID && vcn.export_voyage === this.voyageID && vcn.MlocID === this.areaID);
                if (matchingVcn) {
                    this.vcnID = matchingVcn.vcnID;
                }
            }
        },
        async getShipMovement() {
            if (this.vcnID === 0) {
                useToast().error('Please select a VCN.');
                return;
            }
            useToast().info('Fetching ship movement data...');
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const response = await axios.get(`/get_shipmovements/${this.vcnID}/`, config);
                console.log('Ship movement data response:', response.data);
                this.fetchedList = response.data[2] || [];
                this.fetchedList.sort((a, b) => {
                    const timeStrA = a.movetime.length === 4 ? a.movetime.slice(0, 2) + ':' + a.movetime.slice(2) : a.movetime;
                    const timeStrB = b.movetime.length === 4 ? b.movetime.slice(0, 2) + ':' + b.movetime.slice(2) : b.movetime;
                    const dateA = new Date(`${a.movedate}T${timeStrA}:00`);
                    const dateB = new Date(`${b.movedate}T${timeStrB}:00`);
                    return dateA - dateB;
                });
                this.hasFetchedMovements = true;
                useToast().success('Ship movement data fetched successfully.');
            } catch (error) {
                console.error('Error fetching ship movement data:', error);
                this.hasFetchedMovements = true;
                useToast().error(error.response?.data?.message || 'Error fetching ship movement data.');
            }
        },
        validateMovementEntry() {
            if (!this.move) {
                return { valid: false, message: 'Please select a movement.' };
            }
            if (!this.place) {
                return { valid: false, message: 'Please select a berth.' };
            }
            if (!this.terminal) {
                return { valid: false, message: 'Please select a Place.' };
            }
            if (!this.date) {
                return { valid: false, message: 'Please enter date.' };
            }
            if (!this.time) {
                return { valid: false, message: 'Please enter time.' };
            }

            const move = this.move.toLowerCase();
            const place = this.place.toLowerCase();

            // check rules from table
            if (move === 'arrived' && !place.includes('sandheads')) {
                return { valid: false, message: 'Arrived movement must have berth Sandheads.' };
            }
            if (move === 'waiting' && !/(berth|nsd|hdc|buoys)/i.test(this.place)) {
                return { valid: false, message: 'Waiting movement must have berth or buoys in berth.' };
            }
            if (move === 'berth' && !/(berth|nsd|hdc)/i.test(this.place)) {
                return { valid: false, message: 'Berth movement should have berth number/place.' };
            }
            const naMoves = ['commenced', 'suspended', 'resumed', 'completed', 'sailing'];
            if (naMoves.includes(move) && !/(na|berth|buoys|nsd|hdc)/i.test(this.place)) {
                return { valid: false, message: `${this.move} should have berth as NA, NSD, or HDC.` };
            }
            // transition rules
            const steps = ['arrived', 'waiting', 'berth', 'commenced', 'suspended', 'resumed', 'completed', 'sailing'];
            const existingLast = this.fetchedList.length > 0 ? this.fetchedList[this.fetchedList.length - 1].move.toLowerCase() : null;
            console.log('Existing last move:', existingLast);
            const indexCurrent = steps.indexOf(move);
            const indexExisting = existingLast ? steps.indexOf(existingLast) : -1;
            console.log('Validating movement entry. Current move:', move, 'Existing last move:', existingLast, 'Index current:', indexCurrent, 'Index existing:', indexExisting);
            if (existingLast) {
                const allowedNext = {
                    arrived: ['waiting', 'berth'],
                    waiting: ['berth', 'sailing'],
                    berth: ['commenced', 'completed', 'resumed'],
                    commenced: ['suspended', 'completed'],
                    suspended: ['berth'],
                    resumed: ['completed', 'suspended'],
                    completed: ['waiting', 'sailing'],
                    sailing: []
                };
                //Get last movement and and move date time to compare with current entry for validation
                const lastMovement = this.fetchedList[this.fetchedList.length - 1];
                const timeStrLast = lastMovement.movetime.length === 4 ? lastMovement.movetime.slice(0, 2) + ':' + lastMovement.movetime.slice(2) : lastMovement.movetime;
                const dateLast = new Date(`${lastMovement.movedate}T${timeStrLast}:00`);
                //const dateCurrent = new Date(`${this.date}T${this.time}:00`);
                // Current date input(25/03/2026)(dd/mm/yyyy) format and time should not be before last movement date and time
                const currentDateStr = `${this.date.split('/').reverse().join('-')}T${this.time.slice(0, 2) + ':' + this.time.slice(2)}:00`;
                const dateCurrent = new Date(currentDateStr);
                console.log('Current movement date and time:', dateCurrent, 'Current movement date string:', currentDateStr);
                console.log('Last Movement date and time:', dateLast, 'Actual last movement date and time:', lastMovement.movedate, timeStrLast);
                console.log('Comparing movement dates. Last movement date:', dateLast, 'Current movement date:', dateCurrent);
                if (dateCurrent < dateLast) {
                    return { valid: false, message: 'Current movement date and time cannot be before the last movement.' };
                }
                console.log('Existing last move:', existingLast, 'Current move:', move);
                console.log('Last Movement:', lastMovement, 'Last Movement Date:', dateLast, 'Current Movement Date:', dateCurrent, 'Last Movement Time:', timeStrLast);

                if (move === 'waiting' && !['arrived', 'completed'].includes(existingLast)) {
                    return { valid: false, message: 'Waiting is only applicable after Arrived or Completed.' };
                }

                if (existingLast === 'arrived' && move === 'sailing') {
                    return { valid: false, message: 'After Arrived, next move must be Waiting or Berth, not Sailing.' };
                }

                if (existingLast === 'berth') {
                    const hasCommenced = this.fetchedList.some(item => item.move.toLowerCase() === 'commenced');
                    if (!hasCommenced && move !== 'commenced') {
                        return { valid: false, message: 'After Berth, the next movement must be Commenced first.' };
                    }
                    if (hasCommenced && !['resumed', 'completed'].includes(move)) {
                        return { valid: false, message: 'After Berth and Commenced already done, next movement must be Resumed or Completed.' };
                    }
                }

                if (!allowedNext[existingLast]?.includes(move)) {
                    return { valid: false, message: `${this.move} is not allowed after ${existingLast}.` };
                }

                if (indexCurrent < 0) {
                    return { valid: false, message: `${this.move} is an unknown movement type.` };
                }

            } else {
                if (move !== 'arrived') {
                    return { valid: false, message: 'First movement should be Arrived.' };
                }
            }

            return { valid: true, message: '' };
        },
        async saveVcn() {
            const validation = this.validateMovementEntry();
            if (!validation.valid) {
                useToast().error(validation.message);
                return;
            }
            //Calll api to save in backend as needed. For now, just saving locally in the table.
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const payload = {
                    vcnid: this.vcnID,
                    vesselid: this.vesselID,
                    voyageid: this.voyageID,
                    move: this.move,
                    place: this.place,
                    terminal: this.terminal,
                    movedate: this.date,
                    movetime: this.time,
                    remarks: this.remarks
                };
                console.log('Sending request with payload:', payload);
                const data = new FormData();
                data.append('transaction', JSON.stringify(payload));
                const response = await axios.post('/create_shipmovements/', data, config);
                useToast().success('Ship movement saved successfully.');
                this.fetchedList = response.data[2] || [];
                this.fetchedList.sort((a, b) => {
                    const timeStrA = a.movetime.length === 4 ? a.movetime.slice(0, 2) + ':' + a.movetime.slice(2) : a.movetime;
                    const timeStrB = b.movetime.length === 4 ? b.movetime.slice(0, 2) + ':' + b.movetime.slice(2) : b.movetime;
                    const dateA = new Date(`${a.movedate}T${timeStrA}:00`);
                    const dateB = new Date(`${b.movedate}T${timeStrB}:00`);
                    return dateA - dateB;
                });
                this.hasFetchedMovements = true;
            } catch (error) {
                console.error('Error saving ship movement:', error);
                useToast().error(error.response?.data?.message || 'Error saving ship movement.');
                return;
            }

            //this.move = '';
            //this.place = '';
            //this.date = '';
            this.time = '';
            this.remarks = '';
        },
        async removeMovement(movement) {
            this.showConfirmModal = true;
            this.movementToDelete = movement;
        },
        cancelDelete() {
            this.showConfirmModal = false;
            this.movementToDelete = null;
        },
        async proceedDelete() {
            if (!this.movementToDelete) return;
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const movementId = this.movementToDelete['autoid'];
                const vcnid = this.movementToDelete['vcnID'];
                const response = await axios.delete(`/delete_shipmovements/${movementId}/?vcnid=${vcnid}`, config);
                useToast().success('Movement removed successfully.');
                this.fetchedList = response.data[2];
            } catch (error) {
                console.error('Error removing movement:', error);
                useToast().error(error.response?.data?.message || 'Error removing movement.');
            } finally {
                this.showConfirmModal = false;
                this.movementToDelete = null;
            }
        },
        formatDateInput(event) {
            let value = event.target.value.replace(/\D/g, '');
            if (value.length >= 2) value = value.slice(0, 2) + '/' + value.slice(2);
            if (value.length >= 5) value = value.slice(0, 5) + '/' + value.slice(5);
            if (value.length > 10) value = value.slice(0, 10);
            event.target.value = value;
            this[event.target.id] = value;
        },
        handleBackspace(event) {
            if (event.key === 'Backspace') {
                const input = event.target;
                const start = input.selectionStart;
                const value = input.value;
                if (value[start - 1] === '/') {
                    event.preventDefault();
                    input.setSelectionRange(start - 1, start - 1);
                }
            }
        },
        filterMovements() {
            // Implement filtering logic here
            console.log('Filtering movements:', this.selectedMovement, this.fromDate, this.toDate);
            // For demonstration, just showing a toast. Replace with actual filtering logic.
            useToast().info('Filtering functionality is not implemented yet.');
        },
    }
}
</script>
<style scoped>
.table-container {
    /*max-height: 100%;*/
    overflow: auto;
    border: 1px solid #ddd;
    border-radius: 10px;
}

.transaction-table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
}

.transaction-table th,
.transaction-table td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.transaction-table th {
    background-color: #f2f2f2;
    font-weight: bold;
}

.transaction-table th .filter-icon {
    cursor: pointer;
    margin-left: 5px;
}

/* Form group styling for form elements */
.field-p-100 {
    width: 100%;
}

.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 32%;
}

.form-item2 {
    width: 24%;
}

.form-item3 {
    width: calc(50% - 10px);
    margin-right: 10px;
}

.form-item3:nth-child(2n) {
    margin-right: 0;
}

/* remove right-side spacing and adapt modal to smaller screens */
.modal-content.small {
    width: 95%;
    max-width: 960px;
    padding: 0;
    margin-right: 0;
    box-sizing: border-box;
}

.modal-subtitle {
    margin: 4px 0 0;
    font-size: 0.95rem;
    color: #333;
}

.modal-subtitle-value {
    font-weight: 700;
    font-size: 1.1rem;
    color: #0e5a87;
    margin: 0 4px;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
    width: 100%;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button.compact {
    padding: 6px 10px;
    font-size: 0.9rem;
    min-height: 32px;
}

.page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.page-header h1 {
    margin: 0;
    font-size: 1.6rem;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.add-movement-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 12px;
}

.excel-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

/* Modal styles reused from other components */
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    pointer-events: auto;
}

.modal-content.small {
    width: min(92vw, 940px);
    max-width: 960px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    margin: 1rem;
    box-sizing: border-box;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
}

.modal-body {
    padding: 12px 16px;
    overflow-y: auto;
    flex: 1 1 auto;
}

.modal-footer {
    padding: 12px 16px;
    border-top: 1px solid #eee;
    text-align: right;
}

.cancel-button,
.save-button {
    border: 1px solid transparent;
    border-radius: 4px;
    padding: 8px 16px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.12s ease, background-color 0.12s ease, filter 0.12s ease;
}

.cancel-button {
    background-color: #fff;
    color: #dc3545;
    border-color: #dc3545;
}

.cancel-button:hover {
    background-color: #f8d7da;
    color: #a71d2a;
    transform: translateY(-1px);
}

.save-button {
    margin-left: 10px;
    background-color: #28a745;
    color: #fff;
    border-color: #28a745;
}

.save-button:hover {
    background-color: #218838;
    filter: brightness(1.05);
}

.close-btn {
    padding: 8px 12px;
    border-radius: 4px;
    border: none;
    background: #6c757d;
    color: #fff;
    cursor: pointer;
}

.filter-row {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
}

.filter-section {
    display: flex;
    align-items: center;
    gap: 5px;
}

.filter-section label {
    white-space: nowrap;
    font-weight: bold;
}

.search-button {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9rem;
}

.search-row {
    margin-bottom: 12px;
    display: flex;
    gap: 8px;
    align-items: center;
}

.header-search-row {
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
    display: flex;
    gap: 8px;
    align-items: center;
}

.search-select {
    flex: 0 0 auto;
    width: 120px;
}

.search-input {
    /*flex: 1 1 auto;*/
    width: 250px;
    padding: 6px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.95rem;
}
</style>